import { ClassTypeOptions, ra, ra_property } from '@cundd/rest-adapter';

@ra(ClassTypeOptions.AddUnknownFields)
export class Department {
    @ra_property()
    public title: string = '';

    @ra_property()
    public description: string = '';

    @ra_property()
    public descriptionTitle: string = '';

    @ra_property()
    public referenceId: string = '';

    public static fromData(data: Partial<Department>): Department {
        const department = new Department();
        department.title = data.title || '';
        department.referenceId = data.referenceId || '';
        department.description = data.description || '';
        department.descriptionTitle = data.descriptionTitle || '';

        return department;
    }
}
